import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth } from 'utils/hooks/useAuth';
import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import { authenticationActions } from 'components/Authentication/actions';

const { ACCESS_TOKEN } = LOCAL_STORAGE_KEYS;

export const ExternalLogoutListener = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return () => {
      };
    }
    const listener = (event) => {
      if (event.storageArea !== localStorage || event.key !== ACCESS_TOKEN || event.newValue) {
        return;
      }
      dispatch(authenticationActions.logout());
    };
    window.addEventListener('storage', listener);
    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [dispatch, isAuthenticated]);

  return null;
};
